
import { Event }     from './event';
import { EventType } from './event.type';
import {empty} from "@/util/util";

/**
 *
 * @class ResizeEvent
 *
 * when the external size of the KRPano viewer changes
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2022
 *
 */
export class ResizeEvent extends Event {

  /** width */
  private _w: number       = 0;

  /** height */
  private _h: number       = 0;

  /** rendering scale */
  private _scale: number   = 0;

  /** standard constructor */
  constructor(krpano : any, w: number, h: number, scale: number, type: EventType = EventType.RESIZE) {

    super(krpano, type);

    this._w      = w;
    this._h      = h;
    this._scale  = scale;
  }

  /** external width */
  w(): number {

    return this._w;
  }

  /** external height */
  h(): number {

    return this._h;
  }

  /** rendering scale */
  scale(): number {

    return this._scale;
  }

}
